import * as tslib_1 from "tslib";
import { TranslateService } from '@ngx-translate/core';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
var UpdatedByLogService = /** @class */ (function () {
    function UpdatedByLogService(translateService) {
        this.translateService = translateService;
        this.customAuthorDeviceMapper = Object.freeze({
            mountdoom: 'laptop',
            mordor: 'laptop',
            lorgan: 'upload',
            gorgoroth: 'smartphone',
            system: 'settings',
        });
    }
    UpdatedByLogService.prototype.customUpdatedByInLogs = function (logs) {
        var e_1, _a;
        try {
            for (var logs_1 = tslib_1.__values(logs), logs_1_1 = logs_1.next(); !logs_1_1.done; logs_1_1 = logs_1.next()) {
                var log = logs_1_1.value;
                log = this.generateUpdateByLog(log);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (logs_1_1 && !logs_1_1.done && (_a = logs_1.return)) _a.call(logs_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return logs;
    };
    UpdatedByLogService.prototype.generateUpdateByLog = function (log) {
        var typeLog = log.isCreatedLog ? 'CREATED' : 'UPDATED';
        var authorName = (log.updatedBy && log.updatedBy.name) || log.updatedByName;
        var clientApplicationName = (log.clientApplicationName || 'mountdoom').toUpperCase();
        log.customAuthorDevice = this.customAuthorDeviceMapper[clientApplicationName.toLowerCase()];
        if (log.clientApplicationName === 'mordor') {
            log.customAuthor = [
                this.translateService.instant("RECURRENCES.DIALOG.TABS.HISTORIC.AUTHOR." + typeLog),
                authorName
                    ? this.translateService.instant('RECURRENCES.DIALOG.TABS.HISTORIC.AUTHOR.BY_COMPANY', { authorName: authorName })
                    : this.translateService.instant('RECURRENCES.DIALOG.TABS.HISTORIC.AUTHOR.DEVICES.SYSTEM'),
            ].filter(Boolean).join(' ');
            return log;
        }
        log.customAuthor = [
            this.translateService.instant("RECURRENCES.DIALOG.TABS.HISTORIC.AUTHOR." + typeLog),
            authorName ? this.translateService.instant('RECURRENCES.DIALOG.TABS.HISTORIC.AUTHOR.BY_AUTHOR', { authorName: authorName }) : null,
            this.translateService.instant("RECURRENCES.DIALOG.TABS.HISTORIC.AUTHOR.DEVICES." + clientApplicationName)
        ].filter(Boolean).join(' ');
        return log;
    };
    UpdatedByLogService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UpdatedByLogService_Factory() { return new UpdatedByLogService(i0.ɵɵinject(i1.TranslateService)); }, token: UpdatedByLogService, providedIn: "root" });
    return UpdatedByLogService;
}());
export { UpdatedByLogService };
